import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input} from '@angular/core'

@Component({
  selector: 'cft-youtube-video',
  templateUrl: './youtube-video.component.html',
  styles: [':host { display: contents }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubeVideoComponent {
  videoId = input<string>()

  limitRelatedVideosToSameChannel = input(true)

  showControls = input(true)

  modestBranding = input(true, {transform: booleanAttribute})

  color = input<'white' | 'red'>('red')

  width = input<number | string>(560)

  height = input<number | string>(315)

  rounded = input(false)

  shadow = input(false)

  protected embedUrl = computed(() => `https://www.youtube-nocookie.com/embed/${this.videoId()}?${this.parameters()}`)

  protected parameters = computed(() => {
    const rel = this.limitRelatedVideosToSameChannel() ? 0 : 1
    const controls = this.showControls() ? 1 : 0
    const modestBranding = this.modestBranding() ? 1 : 0
    return `rel=${rel}&controls=${controls}&modestbranding=${modestBranding}&color=${this.color()}&enablejsapi=1`
  })
}
